import React, { useEffect, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Camera } from 'lucide-react'

import { Button } from '../../ui/button'
import Avatar from '../Avatar/Avatar'
import { createUploadWidget } from '../../../utilities/cloudinary'

function UploadButton({ cloudinaryPhotoPublicId, onPhotoUpload, fullName, userId, isStudent }) {
  const widgetRef = useRef(null)

  const ensureWidget = useCallback(() => {
    if (widgetRef.current) return
    if (!process.env.CLOUDINARY_CLOUD_NAME || !process.env.CLOUDINARY_UPLOAD_PRESET) return
    if (typeof window === 'undefined' || !window.cloudinary) return

    try {
      widgetRef.current = createUploadWidget((_error, result) => {
        if (result && result.event === 'success') {
          onPhotoUpload(result.info.public_id)
        }
      })
    } catch (_e) {
      widgetRef.current = null
    }
  }, [onPhotoUpload])

  useEffect(() => {
    ensureWidget()
  }, [ensureWidget])

  return (
    <div className="flex flex-col items-center space-y-3">
      <Avatar
        cloudinaryPhotoPublicId={cloudinaryPhotoPublicId}
        fullName={fullName}
        userId={userId}
        isStudent={isStudent}
        size={24}
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => {
          ensureWidget()
          if (widgetRef.current && widgetRef.current.open) {
            widgetRef.current.open()
          }
        }}
      >
        <Camera className="w-4 h-4 mr-2" />
        Set New Photo
      </Button>
    </div>
  )
}

UploadButton.propTypes = {
  cloudinaryPhotoPublicId: PropTypes.string,
  onPhotoUpload: PropTypes.func,
  fullName: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isStudent: PropTypes.bool
}

export default UploadButton
